// Copyright ©️ 2026 eVolve MEP, LLC

import type { StrongOmit } from '@evolvemep/api-ts';
import { useLocation, type Location } from 'react-router';

import type { LocationState } from './types';

/** Use in place of useLocation */
export const useEvolveLocation = (): StrongOmit<Location, 'state'> & {
  state: LocationState;
} => useLocation();
